export default __webpack_public_path__ + "assets/holiday.7b34fe.png";